import { createFileRoute } from '@tanstack/react-router';
import SsoErrorPage from '../../components/Sso/ErrorPage';

function SsoErrorRoute() {
  return <SsoErrorPage />;
}

export const Route = createFileRoute('/connect/error')({
  component: SsoErrorRoute,
});
